import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { openExternalLink } from "@/lib/openExternalLink";
import { useSiteContent } from "@/hooks/useSiteContent";

export default function Footer() {
  const c = useSiteContent();
  return (
    <footer id="contact" className="bg-[var(--forest-deep)] text-white pt-20 pb-8">
      <div className="container-pl">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-lg bg-[var(--sand)] text-[var(--forest-deep)] flex items-center justify-center font-display font-bold">
                PL
              </div>
              <div>
                <div className="font-display font-bold text-lg">Paraprofessionals Learning Community</div>
                <div className="text-xs tracking-widest uppercase text-white/60">Aotearoa New Zealand</div>
              </div>
            </div>
            <p className="mt-5 text-white/75 max-w-md leading-relaxed">
              The first NZQA-accredited micro-credential designed exclusively for teacher aides
              who support English Language Learners in Aotearoa New Zealand classrooms.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="overline !text-[var(--sand-soft)]">Contact</div>
            <ul className="mt-4 space-y-3 text-white/85" data-testid="footer-contact">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[var(--sand-soft)] mt-1 shrink-0" />
                <a href={`mailto:${c.contact_email}`} data-testid="contact-email" className="hover:text-white">
                  {c.contact_email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[var(--sand-soft)] mt-1 shrink-0" />
                <a href={`tel:${c.contact_phone_href}`} data-testid="contact-phone" className="hover:text-white">
                  {c.contact_phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[var(--sand-soft)] mt-1 shrink-0" />
                <span>{c.contact_location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Linkedin size={18} className="text-[var(--sand-soft)] mt-1 shrink-0" />
                <a
                  href={c.contact_linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => openExternalLink(e, c.contact_linkedin)}
                  className="hover:text-white"
                  data-testid="footer-linkedin"
                >
                  Padma&apos;s LinkedIn profile
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline !text-[var(--sand-soft)]">Site</div>
            <ul className="mt-4 space-y-2 text-white/85">
              <li><a href="#micro-credential" className="hover:text-white">Micro-Credential</a></li>
              <li><a href="#workshops" className="hover:text-white">Workshops</a></li>
              <li><a href="#accreditation" className="hover:text-white">NZQA Accreditation</a></li>
              <li><a href="#team" className="hover:text-white">About Padma</a></li>
              <li><a href="#calendar" className="hover:text-white">Calendar</a></li>
              <li><a href="#register" className="hover:text-white">Enrol now</a></li>
              <li>
                <Link to="/admin" className="text-white/60 hover:text-white text-sm" data-testid="footer-admin-link">
                  Admin login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 grid md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-7">
            <div className="overline !text-[var(--sand-soft)]">In partnership with</div>
            <a
              href="https://www.nzqa.govt.nz/nzqf/search/microcredentials.do?moe=6659"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) =>
                openExternalLink(
                  e,
                  "https://www.nzqa.govt.nz/nzqf/search/microcredentials.do?moe=6659"
                )
              }
              className="mt-3 inline-flex items-center gap-4 group"
              data-testid="footer-summit-link"
            >
              <img
                src="/summit-logo.png"
                alt="Te Ara Teitei — Summit Institute"
                className="h-14 w-auto opacity-95 group-hover:opacity-100 transition"
                loading="lazy"
              />
            </a>
            <p className="mt-4 text-xs text-white/65 max-w-md leading-relaxed">
              Our micro-credential is NZQA-accredited via Te Ara Teitei — Summit Institute
              (NZQA Provider 6659). All learners are concurrently enrolled with Summit
              Institute · NZQA Listing #5684.
            </p>
          </div>
          <div className="md:col-span-5 md:text-right text-xs text-white/55">
            <div>© {new Date().getFullYear()} Paraprofessionals Learning Community</div>
            <div className="mt-1">Ngā mihi nui — built with care in Aotearoa.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
